import { setupStickyCta } from '@helpers/sticky-cta';

setupStickyCta();
